import { render, staticRenderFns } from "./aiConsult.vue?vue&type=template&id=4235cba0&scoped=true"
import script from "./aiConsult.vue?vue&type=script&lang=js"
export * from "./aiConsult.vue?vue&type=script&lang=js"
import style0 from "./aiConsult.vue?vue&type=style&index=0&id=4235cba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235cba0",
  null
  
)

export default component.exports